
import { Component, Vue } from 'vue-property-decorator';
import HeaderLogo from '@/components/Layout/HeaderLogo.vue';

@Component({ components: { HeaderLogo } })
export default class InvalidLink extends Vue {}
